import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

export default async function getMetricEvents({
  farmId,
  namespace,
  year,
  paddockIds = undefined,
  signal = undefined,
}) {
  const response = await apiClient.get(endpoints.metricEvents, {
    params: { farmId, namespace, year, paddockIds },
    signal,
  })
  return unwrapCollection(response)
}
